/** When your routing table is too long, you can split it into small modules **/

// import Layout from '@/layout'

const interestRouter = {
    path: '/',
    component: () => import('@/views/base/Index'),
    children: [
      {
        name: '打印贴息单',
        path: 'interest/:id',
        component: () => import('@/views/interest/print'),
      },
    ],
  }
  
  export default interestRouter